import { getPlatformAdapter } from "../platform/adapter"

export async function copyTextToClipboard(value: string): Promise<void> {
    const platformResult = await getPlatformAdapter().writeClipboard(value)
    if (platformResult.status === "ok") return
    if (getPlatformAdapter().kind === "ios" || getPlatformAdapter().kind === "android") {
        throw new Error(platformResult.status === "failed" ? platformResult.message : platformResult.reason)
    }

    const input = document.createElement("textarea")
    input.value = value
    input.style.position = "fixed"
    input.style.opacity = "0"
    document.body.append(input)
    input.select()
    const copied = document.execCommand("copy")
    input.remove()
    if (!copied) throw new Error(platformResult.status === "failed" ? platformResult.message : platformResult.reason)
}
